import React from "react";
import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { t } from "@/i18n";

export default function LegalFooter() {
  const { lang } = useApp();
  const owned = {
    it: "Piattaforma di proprietà di",
    en: "Platform owned by",
    he: "פלטפורמה בבעלות",
    ru: "Владелец платформы",
  }[lang];
  const agencyLine = {
    it: "Agenzia immobiliare · Mediazione compravendita e locazione immobili",
    en: "Real estate agency · Brokerage of sales and rentals",
    he: "סוכנות נדל״ן · תיווך במכירות והשכרות",
    ru: "Агентство недвижимости · Посредничество при продажах и аренде",
  }[lang];

  return (
    <footer className="border-t border-[#D8CFBB] bg-[#F5F0E6] mt-16">
      <div className="mx-auto max-w-7xl px-6 py-14 grid grid-cols-1 md:grid-cols-3 gap-10">
        <div>
          <img src="/aaron-logo.png" alt="Aaron Properties" className="h-8 w-auto mb-4 opacity-80" />
          <p className="text-xs text-[#7A6E5A] leading-relaxed max-w-xs">{agencyLine}</p>
        </div>
        <div>
          <p className="text-[10px] tracking-[0.3em] uppercase text-[#C5A880] mb-3">{owned}</p>
          <p className="text-sm text-[#2E2A22] font-medium">AARON &amp; PARTNERS S.R.L.</p>
          <p className="text-xs text-[#7A6E5A] mt-2">Via Pescaglia 16, 00146 Roma (RM)</p>
          <p className="text-xs text-[#7A6E5A]">P.IVA / C.F. 01754670535</p>
          <p className="text-xs text-[#7A6E5A]">REA RM-1745221</p>
          <p className="text-xs text-[#7A6E5A]">Cap. Soc. € 10.000,00</p>
        </div>
        <div>
          <p className="text-[10px] tracking-[0.3em] uppercase text-[#C5A880] mb-3">Contatti</p>
          <p className="text-xs text-[#7A6E5A]">PEC: aaron.part@legalmail.it</p>
          <Link
            to="/verify"
            className="mt-4 inline-flex items-center gap-2 text-xs text-[#2E2A22] hover:text-[#C5A880] transition-colors border-b border-[#C5A880] pb-0.5"
            data-testid="footer-verify-link"
          >
            <ShieldCheck className="w-3.5 h-3.5" /> {t("verify_link", lang)}
          </Link>
        </div>
      </div>
      <div className="border-t border-[#E5DDC9] py-5 text-center">
        <p className="text-[10px] tracking-[0.3em] uppercase text-[#B8A98F]">
          © 2026 Aaron &amp; Partners S.r.l. — All rights reserved. Members only. NDNCA required.
        </p>
      </div>
    </footer>
  );
}
